module.exports = __webpack_public_path__ + "static/media/feature-interview-pass@2x.84d0d9d4.png";